import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTER_PATHS } from '../../../lib/utils/router-paths';
import { EndUserFlowLayout } from '../../layouts/EndUserFlowLayout';
import { EndUserHomePage } from '../../../pages/EndUserHomePage';
import { EndUserDemandAreaPage } from '../../../pages/EndUserDemandAreaPage';
import { EndUserBonusOverviewPage } from '../../../pages/EndUserBonusOverviewPage';
import { EndUserWishlistPage } from '../../../pages/EndUserWishlistPage';
import { EndUserStatusPage } from '../../../pages/EndUserStatusPage';
import { EndUserNotFoundPage } from '../../../pages/EndUserNotFoundPage';
import { useAppSelector } from '../../../lib/store/hooks';
import { useGetEndUserData } from '../../../lib/hooks/endUserHooks/useGetEndUserData';
import { MatomoTracker } from '../MatomoTracker';
import { FinderModal } from '../FinderModal';
import { END_USER_FRENCH_TENANT_MODEL_NAME } from '../../../lib/utils/constants';

export const EndUserRoutes = () => {
  const { model, demandArea } = useAppSelector(({ endUser }) => endUser);
  useGetEndUserData();

  const modelShouldBeDeactivated = !model?.activated || !demandArea?.tenant?.activated;

  const isFrenchTenant = demandArea?.project?.name === END_USER_FRENCH_TENANT_MODEL_NAME;

  const MAIN_ROUTER_PATHS = {
    home: isFrenchTenant ? ROUTER_PATHS.homeFr : ROUTER_PATHS.home,
    bonuses: isFrenchTenant ? ROUTER_PATHS.bonusesFr : ROUTER_PATHS.bonuses,
    houseModel: isFrenchTenant ? ROUTER_PATHS.houseModelFr : ROUTER_PATHS.houseModel,
    wishlist: isFrenchTenant ? ROUTER_PATHS.wishlistFr : ROUTER_PATHS.wishlist,
  };

  return (
    <>
      <FinderModal />
      <MatomoTracker />
      <Routes>
        <Route path={ROUTER_PATHS.noMatch} element={<Navigate to={MAIN_ROUTER_PATHS.home} />} />
        <Route element={<EndUserFlowLayout />}>
          <Route path={MAIN_ROUTER_PATHS.home} element={<EndUserHomePage />} />

          <Route path={MAIN_ROUTER_PATHS.houseModel} element={<EndUserDemandAreaPage />}>
            <Route path={`:id`} element={<EndUserDemandAreaPage />} />
          </Route>

          <Route path={MAIN_ROUTER_PATHS.bonuses} element={<EndUserBonusOverviewPage />} />
          <Route path={ROUTER_PATHS.pointsOverview} element={<EndUserStatusPage />} />
          <Route path={MAIN_ROUTER_PATHS.wishlist} element={<EndUserWishlistPage />} />
        </Route>
        <Route
          path={ROUTER_PATHS.notFound}
          element={modelShouldBeDeactivated ? <EndUserNotFoundPage /> : <Navigate to={ROUTER_PATHS.logIn} />}
        />
      </Routes>
    </>
  );
};
